import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

export const style: CSSResult = css`
  .delivery-match-container {
    display: flex;
    flex-direction: column;
    gap: var(--csc-delivery-match-groups-gap, ${csSpacing.spacing05});

    --csc-delivery-match-method-list-gap: ${csSpacing.spacing05};

    --cse-segmented-control-border-width: 1px;
  }
`
